import React from "react";
import { useTranslation } from "react-i18next";
import { TrophyIcon } from "@heroicons/react/24/outline";
import { Profile } from "../../../types/types";
import { formatText } from "../../../utils/common/formatUtils";

interface AchievementsProps {
    member: Profile;
}

const Achievements: React.FC<AchievementsProps> = ({ member }) => {
    const { t } = useTranslation('publicProfile');
    if (!member.fighter) return null;

    return (
        <div className="space-y-4 text-start" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
            <h3 className="text-sm font-medium text-gray-900">
                {t("achievements")}
            </h3>
            <div className="space-y-3">
                {member.fighter.achievementDetails?.length ? (
                    <div className="space-y-2.5">
                        {member.fighter.achievementDetails.map(
                            (achievement: any, index: any) => (
                                <div
                                    key={index}
                                    className="flex items-start gap-3 p-3 rounded-2xl bg-gray-50/70 border border-gray-100 hover:bg-gray-50 transition-colors"
                                >
                                    <div className="w-7 h-7 rounded-xl bg-amber-50 border border-amber-200/60 flex items-center justify-center shrink-0 mt-0.5">
                                        <TrophyIcon className="w-4 h-4 text-amber-500" />
                                    </div>
                                    <span className="text-sm font-medium text-gray-800 leading-relaxed pt-0.5">
                                        {formatText(achievement.text)}
                                    </span>
                                </div>
                            )
                        )}
                    </div>
                ) : (
                    <p className="text-gray-400 text-xs text-center py-8">
                        {t("no_achievements")}
                    </p>
                )}
            </div>
        </div>
    );
};

export default Achievements;
